import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import NavBar from './components/NavBar';
import About from './pages/About';
import Home from "./pages/Home";
import React from 'react';
import Footer from './components/Footer';
import CheckRegistration from './pages/CheckRegistration';
import VoterGuide from './pages/VoterGuide';
import StateInfoHub from './pages/StateInfoHub';
import ReminderSubscriptionForm from './pages/ReminderSubscriptionForm';
import AdminRegister from './pages/admin/AdminRegister';
import AdminLogin from './pages/admin/AdminLogin';
import PartnerLogin from './pages/partner/PartnerLogin';
import CanvasserLogin from './pages/canvasser/CanvasserLogin';
import PartnerRegister from './pages/partner/PartnerRegister';
import CanvasserRegister from './pages/canvasser/CanvasserRegister';
import { Toaster } from 'react-hot-toast';
import PartnerDashboard from './pages/partner/Dashboard';
import PartnerCheckRegistration from './pages/partner/CheckRegistration';
import PartnerSettings from './pages/partner/Settings';
import CanvasserDashboard from './pages/canvasser/Dashboard';
import CanvasserShifts from './pages/canvasser/Shifts';
import AdminDashboard from './pages/admin/DashBoard';
import AdminExports from './pages/admin/Exports';
import AdminPartners from './pages/admin/Partners';
import AdminAuditLogs from './pages/admin/AuditLogs';
import AdminActivity from './pages/admin/Activity';
import CanvasserCheckRegistration from './pages/canvasser/CheckRegistration';
import DemoRequest from './pages/DemoRequest';
import Pricing from './pages/Pricing';
import TemplatePage from './pages/TemplatePage';
import FieldActivity from './pages/partner/FieldActivity';
import PartnerCanvassers from './pages/partner/Canvassers';
import PartnerExports from './pages/partner/Exports';
import PartnerMessagingUsage from './pages/partner/MessagingUsage';
import Payments from './pages/partner/Payments';
import PaymentMethodChangeSuccess from './pages/partner/PaymentMethodChangeSuccess';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { PartnerModeProvider } from './contexts/PartnerModeContext';
import PartnerRouteProtection from './components/PartnerRouteProtection';
import NotFound from './components/NotFound';
import Settings from './pages/admin/Settings';
import AboutUs from './pages/AboutUs';
import PollingLocation from './pages/PollingLocation';
import Vbm from './pages/Vbm';
import PartnerWithUs from './pages/PartnerWithUs';
import PartnerUpgrade from './pages/partner/PartnerUpgrade';
import PartnerUpgradePayment from './pages/partner/PartnerUpgradePayment';
import PartnerUpgradeSuccess from './pages/partner/PartnerUpgradeSuccess';
import PartnerUpgradeFailure from './pages/partner/PartnerUpgradeFailure';
import MessagingSetupSuccess from './pages/partner/MessagingSetupSuccess';
import MessagingPaymentSuccess from './pages/partner/MessagingPaymentSuccess';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import EmbedStart from './pages/EmbedStart';
import ContentManagement from './pages/admin/ContentManagement';
import BillingUsage from './pages/admin/BillingUsage';
import SystemHealth from './pages/admin/SystemHealth';
import CanvasserBatchRequests from './pages/canvasser/BatchRequests';
import PartnerBatchRequests from './pages/partner/BatchRequests';
import SupervisorRegister from './pages/supervisor/SupervisorRegister';
import SupervisorLogin from './pages/supervisor/SupervisorLogin';
import SupervisorDashboard from './pages/supervisor/Dashboard';
import SupervisorCheckRegistration from './pages/supervisor/CheckRegistration';
import SupervisorFieldActivity from './pages/supervisor/FieldActivity';
import SupervisorExports from './pages/supervisor/Exports';
import SupervisorBatchRequests from './pages/supervisor/BatchRequests';
import SupervisorCanvassers from './pages/supervisor/Canvassers';

// Hook to detect embed mode
const useEmbedMode = () => {
  const [isEmbed, setIsEmbed] = React.useState(false);
  
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const embed = urlParams.get('embed') === 'true';
    const embedId = urlParams.get('embed_id');
    setIsEmbed(embed || !!embedId);
  }, []);
  
  return isEmbed;
};

// Initialize Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51O017kGoxPbqLMwDHcuZmkHgPx5sbq9vh5VSfBwNLxTpickaqwkfpvs66GSExmt4bBBMx1Gq2ULnQmlHOXKpeHvh00vtwSAR2r');

function App() {
  const isEmbed = useEmbedMode();
  
  return (
    <Elements stripe={stripePromise}>
        <AuthProvider>
          <PartnerModeProvider>
            <Router>
            <div className="">
              <Toaster position='top-right'/>
              {!isEmbed && <NavBar />}
              <Routes>
                {/* changed the home page to feature the new about us page */}
              <Route path="/" element={<AboutUs />} /> 
              <Route path="/about" element={<AboutUs />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<TemplatePage />} />
              <Route path="/privacy-policy" element={<TemplatePage />} />
              <Route path="/terms-website" element={<TemplatePage />} />
              <Route path="/terms-platform" element={<TemplatePage />} />




              <Route path="/check-registration" element={<CheckRegistration />} />
              <Route path="/voter-guide" element={<VoterGuide />} />
              <Route path="/state/:stateName" element={<StateInfoHub />} />
              <Route path="/reminder-subscription" element={<ReminderSubscriptionForm />} />
              <Route path="/demo" element={<DemoRequest />} />
              <Route path="/polling-location" element={<PollingLocation />} />
              <Route path="/vbm" element={<Vbm />} />
              <Route path="/get-started" element={<PartnerWithUs />} />
              <Route path="/start" element={<EmbedStart />} />
              <Route path="/register-to-vote" element={<Home />} />




              <Route path="/admin/register" element={<AdminRegister />} />
              <Route path="/partner/register" element={<PartnerRegister />} />
              <Route path="/supervisor/register" element={<SupervisorRegister />} />
              <Route path="/canvasser/register" element={<CanvasserRegister />} />



              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/partner/login" element={<PartnerLogin />} />
              <Route path="/supervisor/login" element={<SupervisorLogin />} />
              <Route path="/canvasser/login" element={<CanvasserLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ChangePassword />} />




              {/* Admin Protected Routes */}
              <Route path="/admin/dashboard" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/exports" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <AdminExports />
                </ProtectedRoute>
              } />
              <Route path="/admin/partners" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <AdminPartners />
                </ProtectedRoute>
              } />
              <Route path="/admin/billing-usage" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <BillingUsage />
                </ProtectedRoute>
              } />
              <Route path="/admin/audit" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <AdminAuditLogs />
                </ProtectedRoute>
              } />
              <Route path="/admin/activities" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <AdminActivity />
                </ProtectedRoute>
              } />
              <Route path="/admin/manage" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <ContentManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/settings" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <Settings />
                </ProtectedRoute>
              } />
              <Route path="/admin/system-health" element={
                <ProtectedRoute requiredRole="SYSTEM_ADMIN">
                  <SystemHealth />
                </ProtectedRoute>
              } />

              {/* Canvasser Protected Routes */}
              <Route path="/canvasser/check-registration" element={
                <ProtectedRoute requiredRole="CANVASSER">
                  <CanvasserDashboard />
                </ProtectedRoute>
              } />
              <Route path="/canvasser/shifts" element={
                <ProtectedRoute requiredRole="CANVASSER">
                  <CanvasserShifts />
                </ProtectedRoute>
              } />
              <Route path="/canvasser/batch-requests" element={
                <ProtectedRoute requiredRole="CANVASSER">
                  <CanvasserBatchRequests />
                </ProtectedRoute>
              } />

              {/* Partner Protected Routes */}
              <Route path="/partner/dashboard" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerDashboard />
                </ProtectedRoute>
              } />
              <Route path="/partner/field-activity" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <FieldActivity />
                </ProtectedRoute>
              } />
              <Route path="/partner/settings" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerSettings />
                </ProtectedRoute>
              } />
              <Route path="/partner/registration" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="canvasser">
                    <PartnerCheckRegistration />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />

              <Route path="/partner/canvassers" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <PartnerCanvassers />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />

              <Route path="/partner/exports" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <PartnerExports />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />

              <Route path="/partner/batch-requests" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <PartnerBatchRequests />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />

              <Route path="/partner/messaging-usage" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <PartnerMessagingUsage />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />
              <Route path="/partner/payments" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <Payments />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />
              <Route path="/partner/payment/change" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <PaymentMethodChangeSuccess />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />
              <Route path="/partner/messaging/setup/success" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <MessagingSetupSuccess />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />
              <Route path="/partner/messaging/success" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerRouteProtection requiredMode="partner_admin">
                    <MessagingPaymentSuccess />
                  </PartnerRouteProtection>
                </ProtectedRoute>
              } />

              {/* Partner Upgrade Routes */}
              <Route path="/partner/upgrade" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerUpgrade />
                </ProtectedRoute>
              } />
              <Route path="/partner/upgrade/payment" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerUpgradePayment />
                </ProtectedRoute>
              } />
              <Route path="/partner/upgrade/success" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerUpgradeSuccess />
                </ProtectedRoute>
              } />
              <Route path="/partner/upgrade/failed" element={
                <ProtectedRoute requiredRole="PARTNER">
                  <PartnerUpgradeFailure />
                </ProtectedRoute>
              } />

              {/* Supervisor Protected Routes */}
              <Route path="/supervisor/dashboard" element={
                <ProtectedRoute requiredRole="SUPERVISOR">
                  <SupervisorDashboard />
                </ProtectedRoute>
              } />
              <Route path="/supervisor/field-activity" element={
                <ProtectedRoute requiredRole="SUPERVISOR">
                  <SupervisorFieldActivity />
                </ProtectedRoute>
              } />
              <Route path="/supervisor/canvassers" element={
                <ProtectedRoute requiredRole="SUPERVISOR">
                  <SupervisorCanvassers />
                </ProtectedRoute>
              } />
              <Route path="/supervisor/registration" element={
                <ProtectedRoute requiredRole="SUPERVISOR">
                  <SupervisorCheckRegistration />
                </ProtectedRoute>
              } />
              <Route path="/supervisor/exports" element={
                <ProtectedRoute requiredRole="SUPERVISOR">
                  <SupervisorExports />
                </ProtectedRoute>
              } />
              <Route path="/supervisor/batch-requests" element={
                <ProtectedRoute requiredRole="SUPERVISOR">
                  <SupervisorBatchRequests />
                </ProtectedRoute>
              } />
              
              {/* 404 Not Found Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            {!isEmbed && <Footer />}
          </div>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </PartnerModeProvider>
      </AuthProvider>
    </Elements>
  );
}

export default App;
